import React from 'react';

export default function AdminServicesPage() {

    return (
        <div>
            <div><br/></div>
            <div>ADMIN SERVICES PAGE</div>
            <div><br/><br/></div>
        </div>
    )
};